import { useQuery } from '@zenbusiness/application-commons-graphql';

import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useLogError } from '#client/hooks/useLogError';
import { VALIDATE_APPLICATION } from '#client/queries';

export default function useValidateApplication({ applicationDataId, isSkip = false }) {
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const skipQuery = !applicationDataId || !businessEntityUuid || isSkip;

  const {
    data,
    error: validateApplicationError,
    errors,
    loading: isValidateApplication,
    refetch
  } = useQuery(VALIDATE_APPLICATION, {
    variables: {
      input: {
        applicationDataId,
        businessUuid: businessEntityUuid
      }
    },
    skip: skipQuery,
    noThrow: true,
    skipCache: true
  });

  useLogError(errors, validateApplicationError);

  return {
    validateApplicationError,
    validationData: data?.validateApplication,
    isValidateApplication,
    refetchValidateApplication: refetch
  };
}
